import Bugsnag from '@bugsnag/js'
import { WretchError } from 'wretch/resolver'

const FILTERED_STATUSES = [400, 401, 403, 504]

function extractStatus(error: unknown): number | undefined {
    if (error instanceof WretchError) return error.response?.status
    const e = error as Record<string, unknown> | undefined
    if (typeof e?.status === 'number') return e.status
    return undefined
}

function isCancelled(error: unknown): boolean {
    const e = error as Record<string, unknown> | undefined
    if (!e) return false
    return e.code === 'ERR_CANCELED' || e.name === 'CanceledError' || e.name === 'AbortError' || e.message === 'canceled'
}

function isRouterDeferredAbort(error: unknown): boolean {
    const msg =
        error instanceof Error
            ? error.message
            : typeof (error as { message?: unknown } | null)?.message === 'string'
              ? String((error as { message: string }).message)
              : ''
    return msg.includes('Deferred data aborted')
}

export const bugsnagNotify = (message: string, params = {} as object, error?: unknown) => {
    if (message.includes('Deferred data aborted') || isCancelled(error) || isRouterDeferredAbort(error)) return
    const status = extractStatus(error)
    if (status !== undefined && FILTERED_STATUSES.includes(status)) return

    Bugsnag.notify(message, (event) => {
        event.addMetadata('reporting', { reportingSource: 'manual' })
        event.context = message
        event.addMetadata('params', params)
        if (error instanceof WretchError) {
            event.addMetadata('error', {
                status: error.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                url: error.url,
                method: error.response?.method,
            })
        } else {
            event.addMetadata('error', (error as object | undefined) ?? {})
        }
    })
}